import React from 'react'
import { WeeztixAuth } from '../../components/weeztix-auth'

/**
 * Weeztix OAuth Management Page
 *
 * This page provides an interface for managing Weeztix OAuth authentication.
 * It displays the authentication status, token expiration information,
 * and provides controls for checking health and initiating login.
 */
const WeeztixAuthPage: React.FC = () => {
  return (
    <div className="weeztix-auth-page">
      <WeeztixAuth />
    </div>
  )
}

export default WeeztixAuthPage
